import React from "react";

function TimeBasedGreeting({ textclassName }) {
  const [hour, setHour] = React.useState(new Date().getHours());
  const userName = JSON.parse(localStorage.user)?.first_name || "User";
  let [greetingMessage, setGreetingMessage] = React.useState("");
  React.useEffect(() => {
    if (hour < 12) {
      setGreetingMessage(`Good morning, ${userName}!`);
    } else if (hour < 18) {
      setGreetingMessage(`Good afternoon, ${userName}!`);
    } else {
      setGreetingMessage(`Good evening, ${userName}!`);
    }
  }, [hour]);

  React.useEffect(() => {
    const il = setInterval(() => {
      setHour(new Date().getHours());
    }, 60000);

    return () => {
      clearInterval(il);
    };
  }, []);

  return <header className={textclassName}>{greetingMessage}</header>;
}

export default TimeBasedGreeting;
